import React from 'react';
import { Modal, FormGroup, Col, Button } from 'react-bootstrap';
import './style.scss';

class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);

        this.getAddedGrants = this.getAddedGrants.bind(this);
        this.getRemovedGrants = this.getRemovedGrants.bind(this);
        this.renderNameChange = this.renderNameChange.bind(this);
        this.renderAddedGrants = this.renderAddedGrants.bind(this);
        this.renderRemovedGrants = this.renderRemovedGrants.bind(this);
    }

    getAddedGrants(oldGrants, newGrants) {        
        if (oldGrants == undefined || newGrants == undefined)
            return

        let addedGrants = newGrants.filter(function (obj) {
            return !oldGrants.some(function (obj2) {
                return obj.Type == obj2.Type;
            });
        });

        return Object.values(addedGrants);
    }

    getRemovedGrants(oldGrants, newGrants) {
        if (oldGrants == undefined || newGrants == undefined)
            return

        var removedGrants = oldGrants.filter(function (obj) {
            return !newGrants.some(function (obj2) {
                return obj.Type == obj2.Type;
            });
        });

        return Object.values(removedGrants);
    }

    renderNameChange(oldName, newName) {
        if (oldName != newName) {
            return (
                <div>
                    <h4>Name</h4>
                    <p>From <b>{oldName}</b> to <b>{newName}</b>.</p>
                </div>
            )
        }
    }

    renderAddedGrants(oldGrants, newGrants) {
        let addedGrants = this.getAddedGrants(oldGrants, newGrants);
        if (addedGrants?.length > 0) {

            const distinctGrants = [];
            const map = new Map();
            for (const grant of addedGrants) {
                if (!map.has(grant.Type)) {
                    map.set(grant.Type, true);
                    distinctGrants.push({
                        Type: grant.Type,
                        Name: grant.Name
                    });
                }
            }

            return (
                <div className="margin-bottom-10">
                    <h4>Added grants</h4>
                    <ul className="addedGrants">
                        {distinctGrants.map(x => <li key={x.Type}>{x.Name}</li>)}
                    </ul>
                </div>
            )  
        }    
    }

    renderRemovedGrants(oldGrants, newGrants) {
        let removedGrants = this.getRemovedGrants(oldGrants, newGrants);
        if (removedGrants?.length > 0) {

            const distinctGrants = [];
            const map = new Map();
            for (const grant of removedGrants) {
                if (!map.has(grant.Type)) {
                    map.set(grant.Type, true);
                    distinctGrants.push({
                        Type: grant.Type,
                        Name: grant.Name
                    });
                }
            }

            return (
                <div>
                    <h4>Removed grants</h4>
                    <ul className="removedGrants">
                        {distinctGrants.map(x => <li key={x.Type}>{x.Name}</li>)}
                    </ul>
                </div>
            )
        }
    }

    render() {
        let oldName = this.props.prevRoleName;
        let newName = this.props.roleName;

        let oldGrants = this.props.roleGrants;
        let newGrants = this.props.selectedGrants;

        return (
            <div>
                <Modal show={this.props.showModal} onHide={() => { this.props.toggleModal() }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm role changes: </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        {this.renderNameChange(oldName, newName)}

                        {this.renderAddedGrants(oldGrants, newGrants)}

                        {this.renderRemovedGrants(oldGrants, newGrants)}

                    </Modal.Body>

                    <Modal.Footer>
                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button type="button" bsStyle="primary" onClick={this.props.confirmationSave}>Confirm save</Button>
                            </Col>
                        </FormGroup>
                    </Modal.Footer>
                </Modal>
            </div>
            
        )
    }
}

export default ConfirmationModal;